import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';

export default function ViewReturnModal({ show, handleClose, returnData }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    if (!returnData) return null;

    const calculateTotalItems = () => {
        return returnData?.items?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="return-modal" centered>
            <Modal.Header className={classNames(`${theme}ModalBackground`, styles.ModalHeader)}>
                <div className={styles.HeaderContent}>
                    <div>
                        <Heading heading="Return Order Details" headingStyle={styles.ModalHeading} />
                        <div className={styles.OrderNumber}>{returnData?.order_number}</div>
                    </div>
                    <div className={styles.StatusBadge}>
                        <span className={styles.StatusText}>Completed</span>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.ModalBody)}>
                {/* Info Cards Grid */}
                <div className={styles.InfoGrid}>
                    <div className={classNames(styles.InfoCard, `${theme}ItemBackground`)}>
                        <div className={styles.InfoLabel}>Date & Time</div>
                        <div className={styles.InfoValue}>
                            {moment(returnData?.created_at).format('DD MMM YYYY, HH:mm')}
                        </div>
                    </div>
                    <div className={classNames(styles.InfoCard, `${theme}ItemBackground`)}>
                        <div className={styles.InfoLabel}>Warehouse</div>
                        <div className={styles.InfoValue}>{returnData?.warehouse?.code || 'N/A'}</div>
                    </div>
                    {returnData?.sale_order?.order_number && (
                        <div className={classNames(styles.InfoCard, `${theme}ItemBackground`)}>
                            <div className={styles.InfoLabel}>Sale Order</div>
                            <div className={styles.InfoValue}>{returnData?.sale_order?.order_number}</div>
                        </div>
                    )}
                    <div className={classNames(styles.InfoCard, `${theme}ItemBackground`)}>
                        <div className={styles.InfoLabel}>Total Items</div>
                        <div className={styles.InfoValue}>{calculateTotalItems()} units</div>
                    </div>
                </div>

                {/* Additional Details */}
                {(returnData?.returnPerson || returnData?.referenceNumber || returnData?.reason) && (
                    <div className={classNames(styles.DetailsSection, `${theme}ItemBackground`)}>
                        <div className={styles.SectionTitle}>Additional Information</div>
                        <div className={styles.DetailsGrid}>
                            {returnData?.returnPerson && (
                                <div className={styles.DetailRow}>
                                    <span className={styles.DetailLabel}>Return Person:</span>
                                    <span className={styles.DetailValue}>{returnData.returnPerson}</span>
                                </div>
                            )}
                            {returnData?.referenceNumber && (
                                <div className={styles.DetailRow}>
                                    <span className={styles.DetailLabel}>Reference:</span>
                                    <span className={styles.DetailValue}>{returnData.referenceNumber}</span>
                                </div>
                            )}
                            {returnData?.reason && (
                                <div className={styles.DetailRow}>
                                    <span className={styles.DetailLabel}>Reason:</span>
                                    <span className={styles.DetailValue}>{returnData.reason}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Items Table */}
                <div className={styles.ItemsSection}>
                    <div className={styles.SectionTitle}>Returned Items</div>
                    <div className={classNames(styles.ItemsTable, `${theme}ItemBackground`)}>
                        <div className={styles.TableHeader}>
                            <div className={styles.TableHeaderCell}>SKU</div>
                            <div className={styles.TableHeaderCell}>Quantity</div>
                        </div>
                        <div className={styles.TableBody}>
                            {returnData?.items?.map((item, index) => (
                                <div key={index} className={styles.TableRow}>
                                    <div className={styles.TableCell}>
                                        <span className={styles.SkuBadge}>{item.sku}</span>
                                    </div>
                                    <div className={styles.TableCell}>
                                        <span className={styles.QuantityValue}>{item.quantity}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Footer Actions */}
                <div className={styles.ModalFooter}>
                    <CustomButton
                        text="Close"
                        containerStyle={styles.CloseButton}
                        submitHandle={handleClose}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
}
